import React from 'react';
import PropTypes from 'prop-types';

// Sometimes the processor adds unnecessary p-tags. This function removes them.
function removePTags(html) {
  return html.replace(/<\/?p[^>]*>/g, '');
}

export function HTMLContent({ content, className, includePTags = true }) {
  return (
    <div
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: includePTags ? content : removePTags(content),
      }}
    />
  );
}

function Content({ content, className }) {
  return <div className={className}>{content}</div>;
}

Content.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
};

HTMLContent.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
  includePTags: PropTypes.bool,
};

export default Content;
